import { autoinject } from 'aurelia-dependency-injection';
import { PLATFORM } from 'aurelia-pal';
import { useView } from 'aurelia-templating';
import {
	ClassicPanelDialog,
	ClassicPanelDialogModel,
} from '~/components/classic-panel/classic-panel-dialog';
import { Notification } from '~/components/notification/notification';
import { RestoreDialogUtils } from '~/forms/generic-processing-centre/restore-dialog-utils';
import FormModelUtils from '~/utils/form-model-utils';
import { RestoreBatchApi } from './restore-batch-api';

@autoinject
@useView(PLATFORM.moduleName('./restore-batch-dialog.html'))
export class RestoreBatchDialog extends ClassicPanelDialog<ClassicPanelDialogModel> {
	constructor(protected restoreBatchApi?: RestoreBatchApi, ...rest) {
		super(...rest);
		this.classicFormsApi = this.restoreBatchApi;
		PLATFORM.moduleName('./restore-batch-dialog');
	}

	public activate(
		model: ClassicPanelDialogModel,
	): Promise<ClassicPanelDialogModel> {
		return super.activate(model);
	}

	public attached(): void {
		super.attached();

		const preInsertFormModel = FormModelUtils.cloneModel(
			this.classicPanel.formModel,
		);

		preInsertFormModel.fields.BSi_Identity.forceSave = true;
		// these fields are required when restoring and may be pre-populated with values
		// when a config is turned on so they need to be saved even if they do not change
		preInsertFormModel.fields.BSc_Reverse_Tran.forceSave = true;
		preInsertFormModel.fields.BSc_Cancel_Tran.forceSave = true;
		this.classicPanel.formModel = preInsertFormModel;
		this.classicPanel.setRecordIdSilently(this.model.recordId);

		FormModelUtils.showWarningMessagesIfPresent(preInsertFormModel);
		RestoreDialogUtils.addEventHandlers(
			this.bindingEngine,
			this.classicPanel.formModel.fields,
		);
	}

	public save(): void {
		if (!this.canSave) {
			return;
		}
		this.setIsSaving(true);
		this.classicPanel
			.save(
				this.model.customApi,
				this.model.customHttpMethod,
				this.model.formExtension,
			)
			.then((_) => {
				Notification.success(
					this.i18n.tr(
						'successes.this-record-was-successfully-edited',
					),
				);
				this.controller.ok();
			})
			.catch((rejected) => {
				if (rejected) {
					const errorMessage = rejected.message
						? rejected.message
						: rejected;
					Notification.error(
						this.i18n.tr('errors.unable-to-restore-this-batch', {
							message: errorMessage,
						}),
					);
				}
			})
			.finally(() => {
				this.setIsSaving(false);
			});
	}
}
